import { render, staticRenderFns } from "./historyList.vue?vue&type=template&id=609f6282&scoped=true"
import script from "./historyList.vue?vue&type=script&lang=js"
export * from "./historyList.vue?vue&type=script&lang=js"
import style0 from "./historyList.vue?vue&type=style&index=0&id=609f6282&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609f6282",
  null
  
)

export default component.exports